<!--
 * @Descripttion:
 * @Author: sch
 * @LastEditTime: 2022-04-26 09:30:16
-->
<template>
  <div class="container">
    <div class="no_ask">
      <div class="top_mesage" v-if="$route.query.showbuy != 0">
        <img class="img_product" v-lazy="productObj.img_path">
        <div class="middle_txt">
          <p class="p_top">{{productObj.name}}</p>
          <p class="p_bottom">共{{productObj.problemsnum}}个问题</p>
        </div>
        <span class="rt_btn" @click="goBuy">去购买</span>
      </div>
      <div class="no_concent">
         <div class="ask_no">
          <div class="wen">问</div>
          <div class="txt">{{questionName}}</div>
        </div>
        <div v-if="dataList.length==0">
        <div class="wen_no" >
          <div class="da">答</div>
          <div class="txt">暂无回答</div>
        </div>
        <div class="md_concent">
          <img src="../../../static/images/buyersShow/problemDetails.png">
          <div class="words">暂无回答,去看看别的提问吧~</div>
        </div>
        </div>
        <div class="wen_no" v-if="dataList.length>0">
          <div class="da">答</div>
          <div class="txt">共有{{dataList.length}}条回答</div>
        </div>

        <div class="comment_list" v-if="dataList.length>0">
        <div class="list" v-for="(item,index) of dataList" :key="index">
        <img class="img_user" :src="item.head">
        <div class="middle_txt">
          <p class="p_name">{{item.smallname}} <img v-if="item.vip_level" :src="`/static/images/vipIcon/l${item.vip_level}.png`"/><span v-if="item.isofficia=='0'" class="goumai">已买</span><span v-if="item.isofficia=='1'" class="goumai">官方</span></p>
          <p class="p_txt">{{item.answer}}</p>
          <p class="p_time">{{item.createtime}}</p>
        </div>
        <div class="rt_zan">
          <img :src="getzanStatus(item.islike)" @click="handleClickZan(item,index)">
          <span>{{item.like_nums}}</span>
        </div>
      </div>
        </div>
      </div>
    </div>
      <div class="bottom_block">
        <input v-if="productObj.is_buy==1" type="text" class="inputs" placeholder="请输入您的回答" v-model="inputVal">
        <div v-else @click="inputClick"><input  type="text" class="inputs" v-model="inputVal" disabled="disabled"  placeholder="仅购买过的用户才能回答哦">
        <span class="btn2" @click="submitAnswer(1)">发送</span>
        </div>
        <span v-if="productObj.is_buy==1" class="btn" @click="submitAnswer(0)">发送</span>

      </div>
</div>

</template>
<script>
import { customRequestAjax } from "@/axiosApi";
export default {
  data() {
    return {
      inputVal: "",
      dataList: [],
      questionName: "",
      productObj: {
        img_path: "",
        name: "",
        problemsnum: ""
      }
    };
  },
  created() {
    this.getList();
    this.getProductDetail();
    this.questionName = this.$route.query.questionName;
  },
  methods: {
    getzanStatus(states) {
      let urls =
        states == "1"
          ? "../../../static/images/buyersShow/zanSelect.png"
          : "../../../static/images/buyersShow/zandefault.png";
      return urls;
    },

    getProductDetail() {
      var url =
        "Wxmall/Comment/getQuestionsinfo?itemid=" +
        this.$route.query.itemid +
        "&questionid=" +
        this.$route.query.questionid;
      customRequestAjax(url)
        .then(res => {
          console.log("请求--数据", res.data);
          this.productObj = res.data;
        })
        .catch(err => {});
    },

    getList() {
      var url =
        "Wxmall/Comment/getAnswerist?itemid=" +
        this.$route.query.itemid +
        "&questionid=" +
        this.$route.query.questionid;
      customRequestAjax(url)
        .then(res => {
          console.log("请求数据", res.data.list);
          this.dataList = res.data.list;
        })
        .catch(err => {});
    },
    inputClick() {
      this.$toast("购买过才能回答哦");
    },
    //答案提交
    submitAnswer(val) {
      if (val == 1) {
        this.$toast("购买过才能回答哦");
        this.inputVal = "";
        return;
      }
      if (this.inputVal == "") {
        this.$toast("内容不能为空");
        return;
      }
      this.$ckeckgraphic({
        content: this.inputVal,
        callback: () => {
          var that = this;
          if (this.inputVal.replace(/ /g, "") != "") {
            let urls = "Wxmall/Comment/submitAnswer";
            let data = {
              questionid: this.$route.query.questionid,
              itemid: this.$route.query.itemid,
              answer: this.inputVal
            };
            customRequestAjax
              .post(urls, data)
              .then(res => {
                console.log("回答问题返回", res.data);
                if (res.data.code == 200) {
                  this.$toast("回答成功");
                  this.inputVal = "";
                }
                if (res.data.code == 500) {
                  this.$toast(res.data.msg);
                  this.inputVal = "";
                }
              })
              .catch(err => {});
          } else {
            this.$toast("内容不能为空");
          }
        }
      });
    },
    //点赞和取消
    handleClickZan(item, index) {
      let urls = "Wxmall/Comment/setAnswerlike";
      let data = {
        answerid: item.answerid
      };
      customRequestAjax
        .post(urls, data)
        .then(res => {
          if (res.data.code == 200) {
            let list = this.dataList;
            if (item.islike == "1") {
              item.islike = "0";
              item.like_nums = parseInt(item.like_nums) - 1;
              this.$toast("取消成功");
            } else {
              item.islike = "1";
              item.like_nums = parseInt(item.like_nums) + 1;
              this.$toast("点赞成功");
            }
            this.$set(this.dataList, index, item);
          }
        })
        .catch(err => {});
    },
    goBuy() {
      this.$router.push({
        path: "/productdetail",
        query: {
          itemid: +this.$route.query.itemid
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  background: #f7f4f8;
  font-size: 0.14rem;
  position: relative;
  .no_ask {
    padding: 0 0.11rem;
    .top_mesage {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      padding: 0.15rem 0.11rem 0.04rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.08rem;
      }
      .middle_txt {
        width: 70%;
        .p_top {
          color: #333333;
          font-size: 0.14rem;
          margin-bottom: 0.05rem;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .p_bottom {
          color: #afb0af;
          font-size: 0.12rem;
        }
      }
      .rt_btn {
        width: 0.7rem;
        height: 0.28rem;
        line-height: 0.28rem;
        text-align: center;
        border: 0.01rem solid red;
        color: red;
        border-radius: 0.2rem;
        margin-top: 0.06rem;
      }
    }
    .no_concent {
      margin-top: 0.11rem;
      background: #fff;
      height: calc(100vh - 1.26rem);
      border-radius: 0.08rem 0.08rem 0 0;
      .ask_no {
        width: 93%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0.15rem 0;
        .wen {
          background: red;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0.01rem 0.05rem;
          padding: 0 0.03rem;
          height: 0.2rem;
        }
        .txt {
          font-weight: 600;
          color: #070707;
          font-size: 0.16rem;
        }
      }
      .wen_no {
        width: 93%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0 0 0.15rem;
        border-bottom: 0.01rem solid #c8c9cc36;
        .da {
          background: #72d59c;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0 0.05rem;
          padding: 0 0.03rem;
        }
        .txt {
          font-size: 0.14rem;
          color: #222222;
        }
      }
      .md_concent {
        text-align: center;
        margin-top: 1.35rem;
        img {
          width: 0.8rem;
          height: 0.8rem;
          display: block;
          margin: 0 auto;
        }
        .words {
          margin-top: 0.15rem;
          color: #6e6e6e;
        }
      }
      .comment_list {
        .list {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: flex-start;
          padding: 0.11rem 0 0.12rem 0.1rem;
          .img_user {
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 0.19rem;
            margin-right: 0.12rem;
          }
          .middle_txt {
            width: 76%;
            padding-right: 0.06rem;
            .p_name {
              color: #999999;
              font-size: 0.14rem;
              padding-bottom: 0.05rem;
              .goumai {
                font-size: 0.12rem;
                border: 0.01rem solid red;
                border-radius: 0.03rem;
                padding: 0 0.03rem;
                color: red;
              }
              img{
                width: .3rem;
                height: .14rem;
                display: inline-block;
                vertical-align: middle;
                margin-right: 0.04rem;
              }
            }
            .p_txt {
              color: #333333;
              font-size: 0.14rem;
              padding-bottom: 0.1rem;
            }
            .p_time {
              color: #999999;
              font-size: 0.12rem;
            }
          }
          .rt_zan {
            text-align: center;
            img {
              width: 0.2rem;
              height: 0.2rem;
              margin-left: 0.04rem;
            }
            span {
              color: #999999;
              font-size: 0.12rem;
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0.56rem;
      }
    }
  }

  .bottom_block {
    width: 100%;
    padding: 0.1rem 0.11rem 0.15rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    border-top: 0.01rem solid #00000040;
    .inputs {
      background: #f7f4f8;
      outline: none;
      border: 0.01rem solid #f7f4f8;
      height: 0.3rem;
      width: 77%;
      border-radius: 0.15rem;
      padding-left: 0.1rem;
      color: #333;
    }
    .inputs:focus {
      border: none;
    }
    .btn {
      background: #fc0324;
      color: #fff;
      width: 0.65rem;
      border-radius: 0.15rem;
      height: 0.3rem;
      line-height: 0.3rem;
      display: inline-block;
      text-align: center;
      float: right;
    }
    .btn2 {
      background: #d2cfd2;
      color: #fff;
      width: 0.65rem;
      border-radius: 0.15rem;
      height: 0.3rem;
      line-height: 0.3rem;
      display: inline-block;
      text-align: center;
      float: right;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/buyersShow/problemDetails.vue